import {createTheme} from "@material-ui/core";
import {Overrides} from "./Overrides";
import {BgColors as LightBgColors} from "./LightTheme/bgColors";
import {Colors as LightColors} from "./LightTheme/colors";
import {BorderColors as LightBorderColors} from "./LightTheme/borderColors";
import { BgColors as ContrastLightBg } from "./LightBlacknWhite/bgColors"
import { Colors as ContrastLightColors } from "./LightBlacknWhite/colors"
import { BorderColors as ContrastLightBorders } from "./LightBlacknWhite/borderColors"
import { BgColors as ContrastDarkBg } from "./DarkBlacknWhite/bgColors"
import { Colors as ContrastDarkColors } from "./DarkBlacknWhite/colors"
import { BorderColors as ContrastDarkBorders } from "./DarkBlacknWhite/borderColors"
import config from "../config"

export const ToggleTheme = (mode) => {
    switch (mode) {
      case config.THEMES_MODES.LIGHT:
        return createTheme({
          overrides: Overrides(
            LightBgColors.bgColors,
            LightBorderColors.borderColors,
            LightColors.colors
          ).overrides,
          theme: {
            bgColors: LightBgColors.bgColors,
            colors: LightColors.colors,
            borderColors: LightBorderColors.borderColors
          }
        });
  
      case config.THEMES_MODES.CONTRAST_LIGHT:
        return createTheme({
          overrides: Overrides(
            ContrastLightBg.bgColors,
            ContrastLightBorders.borderColors,
            ContrastLightColors.colors
          ).overrides,
          theme: {
            bgColors: ContrastLightBg.bgColors,
            colors: ContrastLightColors.colors,
            borderColors: ContrastLightBorders.borderColors
          }
        });
  
      case config.THEMES_MODES.CONTRAST_DARK:
        return createTheme({
          overrides: Overrides(
            ContrastDarkBg.bgColors,
            ContrastDarkBorders.borderColors,
            ContrastDarkColors.colors
          ).overrides,
          theme: {
            bgColors: ContrastDarkBg.bgColors,
            colors: ContrastDarkColors.colors,
            borderColors: ContrastDarkBorders.borderColors
          }
        });
  
      default:
        return createTheme()
    }
  }